import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '../common/toast/toastContext';
import { getErrorMessage } from '../utils/errorUtils';

export const profileQueryKeys = {
  myProfile: ['myProfile'] as const,
  user: (userId: string) => ['user', userId] as const,
  travelDocument: (userId: string) => ['travelDocument', userId] as const,
  emergencyContacts: (userId: string) => ['emergencyContacts', userId] as const,
  diveInsurance: (userId: string) => ['diveInsurance', userId] as const,
  diveCertificates: (userId: string) => ['diveCertificates', userId] as const,
  diveEquipment: (userId: string) => ['diveEquipment', userId] as const,
};

type ProfileMutationFeedbackOptions = {
  successMessage: string;
  queryKeys: ReadonlyArray<readonly unknown[]>;
};

export const useProfileMutationFeedback = ({
  successMessage,
  queryKeys,
}: ProfileMutationFeedbackOptions) => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return {
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...profileQueryKeys.myProfile],
        }),
        ...queryKeys.map(queryKey =>
          queryClient.invalidateQueries({ queryKey: [...queryKey] }),
        ),
      ]);
      showToast({ message: successMessage, severity: 'success' });
    },
    onError: (error: unknown) => {
      showToast({
        message: getErrorMessage(error) || 'Save failed. Please try again.',
        severity: 'error',
      });
    },
  };
};
